import { ReturnPeriod } from "@/features/pe_aldd";

export const screeningFloodExposureReturnPeriod: ReturnPeriod = 1500;
